import create from './create';
import update from './update';
import get from './get';

export default [create, update, get];
